'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return [].slice.call(arguments).filter(notEmpty).join(' ');
};

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var notEmpty = function notEmpty(x) {
  return !!x;
};